import {
    savePickupDetailRequestFailed,
    savePickupDetailRequestStarted, savePickupDetailRequestSuccess,
    viewInvoiceDetailFailed,
    viewInvoiceDetailRequest,
    viewInvoiceDetailSuccess
} from "./InvoiceDetailViewActions";
import * as api from "../Api";

export const getInvoiceDetail = (source, invoiceNumber) => {
    return (dispatch) => {
        dispatch(viewInvoiceDetailRequest());
        api.getInvoiceDetail(source, invoiceNumber)
            .then(resp => {
                if (resp.data.success) {
                    dispatch(viewInvoiceDetailSuccess(resp.data.data))
                } else {
                    dispatch(viewInvoiceDetailFailed(resp.data.message))
                }
            })
            .catch(error => {
                dispatch(viewInvoiceDetailFailed(error.message))
            })
    }
}

export const savePickupDetails = (pickupLines, pickupInfo, source, invoiceNumber) => {
    return (dispatch) => {
        dispatch(savePickupDetailRequestStarted());
        api.savePickupDetails({
            invoiceLines: pickupLines,
            pickupInfo: pickupInfo
        }).then(resp => {
            if (resp.data.success) {
                dispatch(savePickupDetailRequestSuccess(resp.data.data))
                setTimeout(() => {
                    dispatch(getInvoiceDetail(source, invoiceNumber));
                }, 500)

            } else {
                dispatch(savePickupDetailRequestFailed(resp.data.message))
            }
        }).catch(error => {
            dispatch(savePickupDetailRequestFailed(error.message))
        })
    }
}
